/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_Best_NoneInputs */

const en_us2_exercise_personal_goal_best_none = /** @type {(inputs: Exercise_Personal_Goal_Best_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing logged with weight yet`)
};

const pt_br2_exercise_personal_goal_best_none = /** @type {(inputs: Exercise_Personal_Goal_Best_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem registro com peso`)
};

const es_419_exercise_personal_goal_best_none = /** @type {(inputs: Exercise_Personal_Goal_Best_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía nada registrado con peso`)
};

const pt_pt2_exercise_personal_goal_best_none = /** @type {(inputs: Exercise_Personal_Goal_Best_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem registos com peso`)
};

const fr_fr2_exercise_personal_goal_best_none = /** @type {(inputs: Exercise_Personal_Goal_Best_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien d'enregistré avec charge pour l'instant`)
};

const de_de2_exercise_personal_goal_best_none = /** @type {(inputs: Exercise_Personal_Goal_Best_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nichts mit Gewicht eingetragen`)
};

const it_it2_exercise_personal_goal_best_none = /** @type {(inputs: Exercise_Personal_Goal_Best_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna registrazione con peso`)
};

/**
* | output |
* | --- |
* | "Nothing logged with weight yet" |
*
* @param {Exercise_Personal_Goal_Best_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_best_none = /** @type {((inputs?: Exercise_Personal_Goal_Best_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_Best_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_best_none(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_best_none(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_best_none(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_best_none(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_best_none(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_best_none(inputs)
	return en_us2_exercise_personal_goal_best_none(inputs)
});
export { exercise_personal_goal_best_none as "exercise-personal.goal_best_none" }